import styled from 'styled-components'

export default styled.div`
  position: absolute;
  z-index: 1;
  right: 0;
  top: 140px;
  margin: 10px 10px 0 0;
`



// WEBPACK FOOTER //
// ./src/components/GeolocationAccuracyDisplay.js